import { GenericAccordion, FieldRow } from '../SettingsUI';
import type { FieldSetting } from '../../types';

const FIELDS = [
  { label: 'Work History', key: 'workHistory' },
  { label: 'Education History', key: 'educationHistory' },
  { label: 'Hobbies & interests', key: 'hobbiesInterests' },
  { label: 'Socials', key: 'socials' },
  { label: 'Department', key: 'department' }
];

interface PersonalPanelProps {
  fieldSettings: Record<string, FieldSetting>;
  updateField: (
    key: string,
    role: 'mentee' | 'mentor' | 'admin' | 'mandatory',
    value: boolean
  ) => void;
}

export function PersonalPanel({ fieldSettings, updateField }: PersonalPanelProps) {
  return (
    <GenericAccordion title="Personal, Career and Studies">
      {FIELDS.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
          onMandatoryChange={(val) => updateField(key, 'mandatory', val)}
        />
      ))}
    </GenericAccordion>
  );
}
